import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { CHANNEL_TYPE_ID, companyId, contactNumberId } from "../../constant/gms-constant";
import { selectSalaryRank } from "../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice";
import { useProposalRidersData } from "../riders/use-rider-data";
import { resetProposalForm } from "../../helper/proposal/proposal-reset-form";
import { useProposalTypeData } from "../proposal/use-proposal-type-data";
import { clearProposalId, clearTypeModal, clearTypeOfProposalStatus, clearUpdateTypeModal } from "../../features/gms-state-and-modal/modal-slice";
import { SubmitType } from "../../types/type";
import { setCurrentStep } from "../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice";
import { formatTinNumber } from "../../utils/tin-number-formater.utils";
import { useLazy } from "../services/lazy/use-lazy";
import { selectCSVFile, selectExistingCsvFilePath } from "../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice";
import { selectRemainingAgeRateState, visibleRemainingAge } from "../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice";
import { SupportingDocumentFile } from "../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.state";
import { useDebounce } from "../utilities/use-debounce";
import { useToastify } from "../../library/toastify/toast-provider";
import { selectAmendmentModalOne } from "../../features/actuarial/request-amendment/request-amendment.slice";
import { useCreateProposalAsDraftMutation, useCreateProposalMutation, useGetIsExistingCompanyProposalQuery, useUpdateProposalMutation } from "../../api/gms/proposal/proposal-api";
import { useUploadMasterCSVFileMutation, useUploadSupportingDocumentsMutation } from "../../api/files/files-api";
import { skipToken } from "@reduxjs/toolkit/query";
import { useModalAccess } from "../../components/global/modal/use-modal-access";

export function useCreateProposalForm() {

    const [originalProposal, setOriginalProposal] = useState<any>(null);
    const { showToastNotify } = useToastify();
    const [createProposal, { isLoading: isLoadingCreateProposal }] = useCreateProposalMutation();
    const [uploadMasterCSVFile, { isLoading: isLoadingUploadMasterCSVFile }] = useUploadMasterCSVFileMutation();
    const [updateProposal, { isLoading: isLoadingUpdateProposal }] = useUpdateProposalMutation();
    const [createProposalAsDraft, { isLoading: isLoadingCreateProposalAsDraft } ] = useCreateProposalAsDraftMutation();
    const [saveSupportingDocuments, { isLoading: isLoadingSaveSupportingDocuments}]= useUploadSupportingDocumentsMutation()
    
    const { getProposalForRenewById } = useLazy();
    const isLoading = isLoadingCreateProposal || isLoadingUpdateProposal || isLoadingCreateProposalAsDraft || isLoadingUploadMasterCSVFile || isLoadingSaveSupportingDocuments
    const { 
        isPrototype, 
        isCustomize, 
        hasOtherSpecifyGC, 
        hasOtherToG, 
        isEmployerEmployeeToG, 
        isOFWToG, 
        isLevelRanking, 
        isUniformCoverage, 
        isSalaryRank, 
        isProductGPA,
        isCoverageType,
        isAmountOfLoansSelected, 
        groupClassification,
        othersGroupClassificationValue,
        natureOfBusinessCategory,
        natureOfBusinessItem,
        typeOfGroup,
        othersTypeOfGroupValue,
        typeOfGroupSubType,
        minAgeProfile,
        maxAgeProfile,
        modeOfPayment,
        proposalTypeState,
        product,
        basicPlan,
        coverage,
        inputsByLevelRanking,
        inputsByUniformCoverage,
        proposalAs,
        basicInformation,
        filesCFE,
        channelType,
        channelTypeSubName,
        channelTypeNumber,
        channelTypeEmail,
        hasAffiliation,
        affiliation,
        amountOfLoans,
        amountOfLoansFAmount,
        minAmountOfLoans,
        maxAmountOfLoans,
        fAmountPortfolio,
        maturityMonths,
        prototype,
        borrowerAge6670,
        borrowerAge6670Amount,
        borrowerAge7175,
        borrowerAge7175Amount,
        borrowerAge7680,
        borrowerAge7680Amount,
        commission,
        services,
        notesCFE,
        portfolioOfLoans,
        forRenew,
        paymentTerm,
        companyContactNumber,
        contactPersonNumber,
    } = useProposalTypeData();
    const { isUpdateProposal, isSubmitAsDraftProposal } = useModalAccess()

    const debouncedGroupName = useDebounce( basicInformation.groupName, 500 );
    const shouldCheckCompany = !isUpdateProposal && debouncedGroupName.trim().length >= 3;

    const queryArg = shouldCheckCompany ? { groupName: debouncedGroupName! } : skipToken;
    const { data: existingCompany, isLoading: isLoadingExistingCompany, isError: isErrorExistingCompany, error: errorExistingCompany, refetch: refetchExistingCompany, isFetching: isFetchingExistingCompany } = useGetIsExistingCompanyProposalQuery(queryArg)
    // const errorMessageExistingCompany = getErrorMessage(errorExistingCompany)
    // const { existingCompany, isFetchingExistingCompany, } = useDynamicQuires({ shouldCheckCompany, debouncedGroupName, });
    const dispatch = useDispatch();
    const [isSaveProposal, setIsSaveProposal] = useState<boolean>(false);
    const [submitType, setSubmitType] = useState<SubmitType | null>(null);
    
    const { currentProposalId } = useModalAccess();
    const remainingAgeBracket = useSelector(visibleRemainingAge);

    const formattedAffiliations = hasAffiliation ? affiliation.map((item) => ({
        company_name: item.name,
        tin_number: formatTinNumber(item.tinNumber),
        address: item.address,
    })) : [];


    const selectedSubTypeIds = typeOfGroupSubType.map(item => item.id);
    const selectedSubTypeOFWId = typeOfGroupSubType[0]?.id ?? null;
    const existingCsvFilePath = useSelector(selectExistingCsvFilePath)
    const levelRanking = inputsByLevelRanking.map((data) => ({
        designation: data.label,
        amount: data.fAmount
    }));

    const salaryRankChecked = useSelector(selectSalaryRank);
    const salaryRanking = salaryRankChecked.map((data) => ({
        designation: data.designation,
        amount: data.salary,
        salary_multiplier: data.multiplierLabel
    }));

    // const paymentTermId = useSelector(selectPaymentTermIdState);
    const proposalRiders = useProposalRidersData();

    const amount_loans_id = isAmountOfLoansSelected ? amountOfLoans?.id : null;
    const loans_amount = isAmountOfLoansSelected ? amountOfLoansFAmount : null;

    const level_ranking = isLevelRanking ? levelRanking : null;
    const uniform_coverage_amount = isUniformCoverage ? inputsByUniformCoverage?.fAmount : null;
    const salary_ranking = isSalaryRank ? salaryRanking : null;

    const other_group_classification = hasOtherSpecifyGC ? othersGroupClassificationValue : null;
    // const other_business_type = hasOtherSpecifyBT ? otherBusinessType : null;
    const sub_group_type_id = isEmployerEmployeeToG
        ? selectedSubTypeIds : isOFWToG
        ? selectedSubTypeOFWId : null;
    const other_group_type = hasOtherToG ? othersTypeOfGroupValue : null;
    const isDirect = channelType?.id !== CHANNEL_TYPE_ID.direct
    const csvFile = useSelector(selectCSVFile)
    const companyContactTypeInfo =
        companyContactNumber?.id === contactNumberId.mobile.id
            ? {
                company_contact_number_type_id: companyContactNumber.id,
                company_contact_number: `+63${basicInformation.companyMobileNo}`,
            }
            : {
                company_contact_number_type_id: companyContactNumber?.id,
                company_contact_number: basicInformation.companyTelephone,
            };
    // const contactPersonContactNumber = useSelector(selectBasicInformationContactPersonNumberId)
    const contactPersonContactTypeInfo =
        contactPersonNumber?.id === contactNumberId.mobile.id
            ? {
                company_contact_number_type_id: contactPersonNumber.id,
                company_contact_number: `+63${basicInformation.contactNumber}`,
            }
            : {
                company_contact_number_type_id: contactPersonNumber?.id,
                company_contact_number: basicInformation.contactTelephone,
            };
    // const rateAmount1865 = ageProfileRateAmount1865 == null || Number.isNaN(ageProfileRateAmount1865) ? 0 : ageProfileRateAmount1865;
    const rateAmount6670 = borrowerAge6670Amount == null || Number.isNaN(borrowerAge6670Amount) ? 0 : borrowerAge6670Amount;
    const rateAmount7175 = borrowerAge7175Amount == null || Number.isNaN(borrowerAge7175Amount) ? 0 : borrowerAge7175Amount;
    const rateAmount7680 = borrowerAge7680Amount == null || Number.isNaN(borrowerAge7680Amount) ? 0 : borrowerAge7680Amount;
    const remainingAgeBorrower = useSelector(selectRemainingAgeRateState);
    const borrowerAmounts = remainingAgeBracket
        .filter(item => item.isShow)
        .reduce((acc, item) => {
            const key =
                item.typeOfAge === "main"
                    ? `borrower_amount_18_65`
                    : `borrower_amount_${item.typeOfAge}`;

            acc[key] = item.amount ?? 0;
            // key of under_min
            // key of under_max
            return acc;
        }, {} as Record<string, number>);
    const setBorrowerRemainingAge = remainingAgeBorrower
    .filter(item => item.isShow)
    .reduce((acc, item) => {
        if (item.typeOfAge === "main") {
            acc.borrower_amount_18_65 = item.amount ?? "";
        } else {
            const suffixValue =
                item.typeOfAge === "under_min"
                    ? "under_min"
                    : "under_max";
            const suffixAmount =
                item.typeOfAge === "under_min"
                    ? "under_min"
                    : "over_max";

            // acc[`borrower_${suffix}`] = item.value ?? false;
            // acc[`borrower_amount_${suffix}`] = item.amount ?? "";
            acc[`borrower_${suffixValue}`] = item.typeOfAge === "under_min" ? false : (item.value ?? false);
            acc[`borrower_amount_${suffixAmount}`] = item.typeOfAge === "under_min" ? 0 : (item.amount ?? 0);
        }

        return acc;
    }, {} as Record<string, string | number | boolean>);


    const saveUpdateAsDraft = isUpdateProposal &&  submitType === 'draft';
    const saveUpdateAsFinal = isUpdateProposal && submitType === 'final'

    const proposalData = {
        ...(saveUpdateAsDraft && {application_id: currentProposalId}),
        "channel_type_id": channelType?.id, 
        ...( isDirect ? { 
            "channel_name": channelTypeSubName,
            "channel_number": String(channelTypeNumber),
            "channel_email": channelTypeEmail,
        } : {}),
        "proposal_status_id": proposalAs?.id,
        
        "group_name": basicInformation.groupName,
        "business_nature_id": natureOfBusinessCategory?.id,
        "sub_business_nature_id": natureOfBusinessItem?.id,
        "number_of_lives": basicInformation.noOfLives,
        "business_address": basicInformation.completeBusinessAddress,
        "proposal_addressee": basicInformation.proposalAddress,
        "addressee_designation": basicInformation.addressDesignation,
        // SEC || TIN
        "company_type_info": [
            { company_number_type_id: companyId.tinNumber.id, company_number: basicInformation.tinNumber, },
            { company_number_type_id: companyId.secNumber.id, company_number: basicInformation.secNumber, }
        ],
        // MOBILE || TELEPHONE
        "company_contact_info": [
            companyContactTypeInfo
        ],

        "contact_person_salutation": basicInformation.contactPersonSalutation,
        "contact_person_firstname": basicInformation.contactPersonFirstName,
        "contact_person_mi": basicInformation.contactPersonMiddleName,
        "contact_person_lastname": basicInformation.contactPersonLastName,
        // "fax_number": contactPersonMobileNumber,
        "contact_number_info": [
            contactPersonContactTypeInfo
        ],
        "email": basicInformation.email,
        "designation": basicInformation.designation,
        
        
        "group_classification_id": groupClassification?.id,
        "other_group_classification": other_group_classification,
        // "other_business_type": other_business_type, // to be remove
        
        "group_type_id": typeOfGroup?.id,
        "sub_group_type_id": sub_group_type_id,
        "other_group_type": other_group_type,
        "minimum_age": minAgeProfile,
        "maximum_age": maxAgeProfile,
        "payment_mode_id": modeOfPayment?.id,
        "type_of_proposal_id": proposalTypeState?.id,

        "affiliates": formattedAffiliations,
        // CUSTOMIZE
        ...(isCustomize && product?.id != null && { plan_id: product.id, }),
        ...(isCustomize && basicPlan?.id != null && { basic_plan_id: basicPlan.id, }),
        ...(isCustomize && commission != null && { commission_rate: String(commission), }),
        ...(isCustomize && services != null && { service_fee: String(services), }),
        // COVERAGE
        ...( isCustomize && isCoverageType ? { "coverage_type_id": coverage?.id } : {}),
        ...( isCustomize && isCoverageType ? { "level_ranking": level_ranking } : {}),
        ...( isCustomize && isCoverageType ? { "uniform_coverage_amount": uniform_coverage_amount } : {}),
        ...( isCustomize && isCoverageType ? { "salary_ranking": salary_ranking } : {}),
        // AMOUNT OF LOANS
        // NOTES: amounts for summary of benefits and notes for riders
        ...( isCustomize && isAmountOfLoansSelected ? { "amount_loans_id": amount_loans_id } : {}),
        ...( isCustomize && isAmountOfLoansSelected ? { "loans_amount": loans_amount } : {}),
        ...( isCustomize && isAmountOfLoansSelected ? { "max_loan_amount": maxAmountOfLoans } : {}), //bew 
        ...( isCustomize && isAmountOfLoansSelected ? { "min_loan_amount": minAmountOfLoans } : {}), // new
        ...( isCustomize && isAmountOfLoansSelected ? { "loan_portfolio_amount": portfolioOfLoans } : {}), // new
        ...( isCustomize && isAmountOfLoansSelected
            ? {
                "payment": [
                    {
                        "payment_term_id": paymentTerm?.id,
                        "sub_payment_term_id": maturityMonths, // new
                    },
                ],
            } : {}),
        
        ...(isCustomize ? { "riders" : proposalRiders } : {}),
        ...(isCustomize ? { "notes": notesCFE.length > 0 ? notesCFE : null } : {}),
        ...(isCustomize ? { "borrower_age_66_70": isProductGPA ? false : borrowerAge6670 } : {}), 
        ...(isCustomize ? { "borrower_age_71_75": isProductGPA ? false : borrowerAge7175 } : {}), 
        ...(isCustomize ? { "borrower_age_76_80": isProductGPA ? false : borrowerAge7680 } : {}),
        // ...(isCustomize ? { "borrower_amount_18_64": ageProfileRateAmount1865 } : {}), // new
        // ...(isCustomize ? { "borrower_amount_18_65": rateAmount1865 } : {}), // new
        // ...(isCustomize ? borrowerAmounts : {}),
        ...(isCustomize ? setBorrowerRemainingAge : {}),
        
        ...(isCustomize ? { "borrower_amount_66_70": borrowerAge6670 ? rateAmount6670 : null } : {}), // new
        ...(isCustomize ? { "borrower_amount_71_75": borrowerAge7175 ? rateAmount7175 : null } : {}), // new
        ...(isCustomize ? { "borrower_amount_76_80": borrowerAge7680 ? rateAmount7680 : null } : {}), // new
        // PROTOTYPE
        ...(isPrototype ? { "prototype_id": prototype?.id } : {}),
    }

    const amendmentModalOne = useSelector(selectAmendmentModalOne);
    const isRequestAmend = amendmentModalOne === "isRequesting";
    const handleSaveClientData = (typeBtn: SubmitType) => {
        // if(isRequestAmend) {
        //     return;
        // }
        setSubmitType(typeBtn);
        setIsSaveProposal(true);
    };
    // const currentStatus = useSelector(selectedCurrentProposalStatusName);
    const handleSubmitProposal = async () => {
        
        if(isRequestAmend) {
            dispatch(clearUpdateTypeModal());
            return;
        }
        const supportingFiles = filesCFE
            .filter((item): item is SupportingDocumentFile & { file: File } => item.type === "new" && item.file != null)
            .map(item => item.file);
        try {
            if (isSalaryRank && !csvFile && !existingCsvFilePath) {
                return showToastNotify( "Salary Rank requires a master list file attachment before submission.", "warning");
            }

            let finalResult;

            if (saveUpdateAsFinal) {
                if (!currentProposalId) return;
                if (isPrototype && !basicInformation.tinNumber?.trim() && !basicInformation.secNumber?.trim()) {
                    return showToastNotify("Please provide either a TIN or SEC number for prototype proposal.", "warning");
                }
                finalResult = await updateProposal({ proposalId: currentProposalId, updatedProposal: proposalData }).unwrap();
            } else if (saveUpdateAsDraft) {
                if (!currentProposalId) return;
                finalResult = await createProposalAsDraft(proposalData).unwrap();
            } else if (isSubmitAsDraftProposal) {
                finalResult = await createProposalAsDraft(proposalData).unwrap();
            } else {
                if (isPrototype && !basicInformation.tinNumber?.trim() && !basicInformation.secNumber?.trim()) {
                    return showToastNotify("Please provide either a TIN or SEC number for prototype proposal.", "warning");
                }
                finalResult = await createProposal(proposalData).unwrap();
            }

            // Upload CSV
            if (csvFile) {
                await uploadMasterCSVFile({ proposalID: finalResult.data.application_id, file: csvFile }).unwrap();
            }

            // Upload supporting docs
            if (supportingFiles.length > 0) {
                await saveSupportingDocuments({ proposalID: finalResult.data.application_id, files: supportingFiles, }).unwrap();
            }

            // Everything succeeded
            showToastNotify(finalResult.message, "success");

            // Close modal AFTER success
            dispatch(clearUpdateTypeModal());
            dispatch(clearProposalId());
            dispatch(clearTypeOfProposalStatus());
            dispatch(clearTypeModal());
            dispatch(setCurrentStep(1));

            resetProposalForm(dispatch);

            setIsSaveProposal(false);
            setSubmitType(null);
        } catch (error: any) {
            const errorMsg = error.error || error.errors?.[0]?.msg || error.data?.errors?.[0]?.msg || "An unexpected error occurred";
            showToastNotify(errorMsg, "error");
        }
    };

    const handlePopulateRenewProposal = async () => {
        if (!forRenew?.id) return;
        try {
            await getProposalForRenewById({ proposalId: forRenew.id, }).unwrap();
        } catch (error: any) {
            const errorMsg = error.message
            const errorMessage = errorMsg || error.errors?.[0]?.msg || "An unexpected error occurred";
            showToastNotify(errorMessage, 'error');
        }
    }

    return {
        // setCurrentStep,
        isSaveProposal,
        setIsSaveProposal,
        handleSaveClientData,
        handleSubmitProposal,
        isLoading,
        proposalData,
        submitType,

        handlePopulateRenewProposal,

        existingCompany,
        isFetchingExistingCompany,
        debouncedGroupName,

        originalProposal,
        setOriginalProposal,

        isLoadingCreateProposal,
        isLoadingUploadMasterCSVFile,
        isLoadingUpdateProposal,
        isLoadingCreateProposalAsDraft,
        isLoadingSaveSupportingDocuments
    };
}